import { ReactNode, useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useIsMobile } from "@/hooks/use-mobile";

type AdminLayoutProps = {
  children: ReactNode;
  title: string;
  actionButton?: ReactNode;
  mainClassName?: string;
};

const AdminLayout = ({
  children,
  title,
  actionButton,
  mainClassName,
}: AdminLayoutProps) => {
  const isMobile = useIsMobile();

  // Get initial collapsed state from localStorage immediately (not in useEffect)
  const initialCollapsed = localStorage.getItem("sidebar-collapsed") === "true";
  const [sidebarCollapsed, setSidebarCollapsed] = useState(initialCollapsed);

  // Store collapsed state in localStorage when it changes
  const toggleSidebar = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    localStorage.setItem("sidebar-collapsed", String(newState));
  };

  // Auto-collapse sidebar on mobile
  useEffect(() => {
    if (isMobile && !sidebarCollapsed) {
      setSidebarCollapsed(true);
      localStorage.setItem("sidebar-collapsed", "true");
    }
  }, [isMobile, sidebarCollapsed]);

  return (
    <div className="flex h-screen overflow-hidden fixed inset-0">
      {/* Only show sidebar on desktop */}
      {!isMobile && <Sidebar collapsed={sidebarCollapsed} />}

      <div className="flex flex-col flex-1 overflow-hidden">
        <Header
          title={title}
          actionButton={actionButton}
          sidebarCollapsed={sidebarCollapsed}
          onToggleSidebar={toggleSidebar}
        />
        <main
          className={
            mainClassName || "flex-1 overflow-y-auto p-6 bg-background"
          }
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
